import { FormForType, formFor } from "fw-model";
import { User } from "models/user";

export type FormForUser = FormForType<User>;

export class CreateUserAction {
    public created: User = null;
    constructor(public form: FormForUser) {}
}

export class UpdateUserAction {
    public updated: User = null;
    constructor(public form: FormForUser) {}
}

export class UpdatedUserAction {
    constructor(public user: User) {}
}

export const createUserFormCreator = formFor(User, (s) => {
    s.requiredField((f) => f.FirstName, "First Name");
    s.requiredField((f) => f.LastName, "Last Name");
    s.requiredField((f) => f.EmailAddress, "Email");
    s.requiredField((f) => f.Type, "Type");
    s.requiredField((f) => f.IsActive, "Status");
});

export const updateUserFormCreator = formFor(User, (s) => {
    s.requiredField((f) => f.Id, "Id");
    s.requiredField((f) => f.FirstName, "First Name");
    s.requiredField((f) => f.LastName, "Last Name");
    s.requiredField((f) => f.EmailAddress, "Email");
    s.requiredField((f) => f.Type, "Type");
    s.requiredField((f) => f.IsActive, "Status");
});
